<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.881" height="21.333" viewBox="0 0 10.881 21.333">
        <path
            id="icons8-facebook-30"
            d="M11.556,24.333V13.667H8V10.111h3.556V8.2c0-3.615,1.761-5.2,4.765-5.2a17.324,17.324,0,0,1,2.56.156v3.4H16.832c-1.276,0-1.721.673-1.721,2.036v1.519h3.738l-.508,3.556h-3.23V24.333Z"
            transform="translate(-8 -3)"
            fill="currentColor" />
    </svg>
</template>
